/* eslint-disable complexity */
import React, { FC } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import { UISystemIcon } from '@futrli/ui-components';

import { usePredictionsInfoContext } from '../../context/predictions-info-context';
import { useDataGridLayout } from '../../../../ui/data-grid/components/data-grid-layout-context';

import styles from './period-table-control.scss';

interface Props {
  onBackClick: (event: React.MouseEvent<HTMLElement>) => void;
  onForwardClick: (event: React.MouseEvent<HTMLElement>) => void;
  hideCashGraph?: boolean;
}

export enum DIRECTION {
  'back',
  'forward'
}

export const PeriodTableControl: FC<Props> = ({ onBackClick, onForwardClick, hideCashGraph }) => {
  const intl = useIntl();
  const { rowHeaderWidth } = usePredictionsInfoContext();
  const dataGridLayout = useDataGridLayout();

  if (dataGridLayout?.fitsInViewport) {
    return null;
  }

  const hideCashGraphStyles = hideCashGraph ? { top: -4 } : {};
  return (
    <div
      className={classNames(styles.wrapper, styles.tableControlsPosition)}
      style={{ paddingLeft: rowHeaderWidth, ...hideCashGraphStyles }}
      data-testid="period-table-control"
    >
      <button
        data-testid="period-table-control-back-button"
        onClick={onBackClick}
        className={classNames(styles.controlBtn, styles.controlBtnBackLabel)}
        aria-label={intl.formatMessage({
          id: 'predict.period_table_control_back_button.aria_label',
          defaultMessage: 'Period table control back button'
        })}
      >
        <UISystemIcon iconName="arrow-left-boxed" width={20} height={20} />
      </button>

      <button
        data-testid="period-table-control-forward-button"
        aria-label={intl.formatMessage({
          id: 'predict.period_table_control_forward_button.aria_label',
          defaultMessage: 'Period table control forward button'
        })}
        onClick={onForwardClick}
        className={classNames(styles.controlBtn, styles.controlBtnFwdLabel)}
      >
        <UISystemIcon iconName="arrow-right-boxed" width={20} height={20} />
      </button>
    </div>
  );
};
